module.exports = __webpack_public_path__ + "static/media/about-us.d1b39a10.png";